<div>
  <mat-form-field class="field-stretch field-no-padding-bottom">
    <input matInput readonly value="{{ T_SCOPE + '.' + i18Key | translate | uppercase }}" />
    <div
      class="color-picker-type-container"
      [colorPicker]="color"
      (colorPickerChange)="onColorPickerChange($event)"
      [style.background]="color"
      id="colorPickerDiv"
    ></div>
  </mat-form-field>
</div>
